import type { ContactsView } from '@/pages/StaffContactsView.types'

export type EventsView = Extract<
  ContactsView,
  {
    kind: 'events-list' | 'event-new' | 'event-detail' | 'event-order-new' | 'event-check-in'
  }
>

export function isEventsView(view: ContactsView): view is EventsView {
  return ['events-list', 'event-new', 'event-detail', 'event-order-new', 'event-check-in'].includes(
    view.kind,
  )
}

export function initialEventView(path: string): EventsView | undefined {
  const checkInMatch = path.match(/^\/events\/manage\/(\d+)\/check-in$/)
  if (checkInMatch) return { kind: 'event-check-in', eventId: Number(checkInMatch[1]) }
  const newOrderMatch = path.match(/^\/events\/manage\/(\d+)\/orders\/new$/)
  if (newOrderMatch) return { kind: 'event-order-new', eventId: Number(newOrderMatch[1]) }

  // The Orders tab is the event page's default; the old Orders address still opens it.
  const eventMatch = path.match(/^\/events\/manage\/(\d+)(?:\/orders)?$/)
  if (eventMatch) return { kind: 'event-detail', eventId: Number(eventMatch[1]) }
}
